import React from "react";
import "./index.css";
import "react-phone-input-2/lib/style.css";
import reportWebVitals from "./reportWebVitals";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import WebForm from "./components/WebForm";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { CAPTCHA_SITE_KEY, BASE_DOMAIN } from "./utils/constants";
import { ToastProvider } from "./context/ToastContext";
import ToastContainer from "./components/Toast/ToastContainer";

const siteKey = CAPTCHA_SITE_KEY;

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/webform">
      <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
        <ToastProvider>
          <WebForm />
          <ToastContainer />
        </ToastProvider>
      </GoogleReCaptchaProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
